import React, { Component } from "react";
import Tabs from "../profile/DetailProfilBidang";

import Banner from "../../components/Banner";
function TabContent1() {
  return (
    <div className="tab-content fade-in">
      <div
        className={`tab-pane fade shadow rounded bg-white show active p-5 mt-2 animated backInUp`}
      >
        <div className="section-heading">
          <h4 className="custom-text">Balai TIKOMDIK </h4>
          <p className="custom-text">
            Balai Teknologi Informasi dan Komunikasi Pendidikan mempunyai tugas
            pokok menyelenggarakan kegiatan teknis operasional dan/ atau
            kegiatan teknis penunjang tertentu bidang teknologi informasi dan
            komunikasi pendidikan, meliputi pengembangan dan produksi serta
            pelayanan dan promosi.
          </p>
        </div>
      </div>
    </div>
  );
}

function TabContent2() {
  return (
    <div className="tab-content fade-in">
      <div
        className={`tab-pane fade shadow rounded bg-white show active p-5 mt-2 animated backInUp`}
      >
        <div className="section-heading">
          <h2>
            <em>Tugas dan Fungsi</em>
          </h2>
          <h4>
            <ol className="custom-list">
              <li className="custom-text">
                Penyelenggaraan pengkajian bahan kebijakan teknis pengelolaan
                teknologi informasi dan komunikasi pendidikan;{" "}
              </li>
              <li className="custom-text">
                Penyelenggaraan pengelolaan teknologi informasi dan komunikasi
                pendidikan meliputi pengembangan dan produksi serta pelayanan
                dan promosi;{" "}
              </li>
              <li className="custom-text">
                Penyelenggaraan evaluasi dan pelaporan UPTD Teknologi Informasi
                dan Komunikasi Pendidikan; dan
              </li>
              <li className="custom-text">
                Penyelenggaraan fungsi lain sesuai dengan tugas pokok dan
                fungsinya
              </li>
            </ol>
          </h4>
        </div>
      </div>
    </div>
  );
}

const tabs = [
  { id: "tab1", label: "Tentang TIKOMDIK" },
  { id: "tab2", label: "Tugas dan Fungsi" },
];
function ProfilTikomdik() {
  return (
    <>
      {" "}
      <Banner
        menu={"Profil Balai Tikomdik"}
        desc={
          "Menyajikan informasi mengenai Balai Tikomdik Dinas Pendidikan Jawa Barat"
        }
      />
      <Tabs tabs={tabs} defaultTab="tab1">
        {(activeTab) => {
          if (activeTab === "tab1") {
            return <TabContent1 />;
          } else if (activeTab === "tab2") {
            return <TabContent2 />;
          }
        }}
      </Tabs>
    </>
  );
}

export default ProfilTikomdik;
